import { STROKE_COLOR_PASSIVE } from '@/web-components/import-wizard-v2/constants';
import { v4 as uuidv4 } from 'uuid';

export function drawPanelLines(
  printPositionHeight: number,
  xPositionOfDottedLine: number
) {
  const lines = [];
  let space = 0;

  lines.push({
    x1: xPositionOfDottedLine,
    y1: 0,
    x2: xPositionOfDottedLine,
    y2: 20,
    strokeColor: [1, 0, 0],
  });

  for (let index = 1; space < printPositionHeight; index++) {
    if (index % 2 === 0) {
      lines.push({
        x1: xPositionOfDottedLine,
        y1: space + 20,
        x2: xPositionOfDottedLine,
        y2: space + 40,
        strokeColor: [1, 0, 0],
      });
    } else {
      lines.push({
        x1: xPositionOfDottedLine,
        y1: space + 20,
        x2: xPositionOfDottedLine,
        y2: space + 40,
        strokeColor: [0, 0, 0, 0],
      });
    }
    space = space + 20;
  }

  return lines;
}

export function generateTargetCoordinates(
  panelsPositions: number[],
  index: number,
  height: number,
  y: number
) {
  const strokeColor = STROKE_COLOR_PASSIVE;
  return [
    {
      id: uuidv4(),
      x1:
        panelsPositions[index] +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y1: y + height / 5,
      x2:
        panelsPositions[index] +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y2: y + height - height / 5,
      isInteractive: true,
      strokeColor,
      strokeWidth: 2,
      panelNo: index + 1,
    },
    {
      id: uuidv4(),
      x1:
        panelsPositions[index] -
        20 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y1: y + height / 2 - 20,
      x2:
        panelsPositions[index] +
        20 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y2: y + height / 2 + 20,
      isInteractive: false,
      strokeColor,
      strokeWidth: 2,
      panelNo: index + 1,
    },
    {
      id: uuidv4(),
      x1:
        panelsPositions[index] +
        (panelsPositions[index + 1] - panelsPositions[index]) / 4 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y1: y + height / 2,
      x2:
        panelsPositions[index] -
        (panelsPositions[index + 1] - panelsPositions[index]) / 4 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y2: y + height / 2,
      isInteractive: true,
      strokeColor,
      strokeWidth: 2,
      panelNo: index + 1,
    },
    {
      id: uuidv4(),
      x1:
        panelsPositions[index] +
        20 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y1: y + height / 2 - 20,
      x2:
        panelsPositions[index] -
        20 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y2: y + height / 2 + 20,
      isInteractive: false,
      strokeColor,
      strokeWidth: 2,
      panelNo: index + 1,
    },
    {
      id: uuidv4(),
      x1:
        panelsPositions[index] +
        20 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y1: y + height / 2 - 20,
      x2:
        panelsPositions[index] -
        20 +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y2: y + height / 2 + 20,
      isInteractive: false,
      strokeColor,
      strokeWidth: 2,
      panelNo: index + 1,
    },
    {
      id: uuidv4(),
      x:
        panelsPositions[index] +
        (panelsPositions[index + 1] - panelsPositions[index]) / 2,
      y: y + height / 2,
      rx: 2,
      ry: 2,
      backgroundColor: [68, 206, 100],
      isInteractive: false,
      panelNo: index + 1,
    },
  ];
}

export function getActivePanelNumber(itemX: number, panels: number[]) {
  let panelNo;
  for (let index = 0; index < panels.length; index++) {
    if (itemX > panels[index] && itemX < panels[index + 1]) {
      panelNo = index + 1;
    }
  }
  return panelNo;
}
